module.exports = require("@swa-ui/application/src/ManageAppSettings/ManageAppSettings.module.scss");